export const dateTimeFormat = {
  DEFAULT: "yyyy/MM/dd",
  DATETIME_DEFAULT: "yyyy/MM/dd HH:mm",
  DATETIME_JP: "yyyy年MM月dd日 HH:mm:ss",
  DATE_JP: "yyyy年MM月dd日",
  YEAR_MONTH_JP: "yyyy年MM月",
  HOUR_MINUTE: "HH:mm",
  TIME: "HH:mm:ss",
  DATE_JP_SLASH: "dd/MM/yyyy",
};
